import Form from "react-bootstrap/Form";
import Select from 'react-select';

import { uncategorizedText } from "../../constants";
import { CategoryWithCountsViewModel } from "../../apiClient";
import { getReactSelectStyles } from "../../helpers/reactSelectTheme";

export enum CountType {
    Bookmarks,
    Videos,
}

type Props = {
    categories: CategoryWithCountsViewModel[];
    onChange: (value: string) => void;
    value: string;
    name: string;
    countType: CountType;
    compact?: boolean;
    allLabel?: string;
    autoFocus?: boolean;
    disabled?: boolean;
};

const getLabel = (category: CategoryWithCountsViewModel, countType: CountType) =>
    `${category.name} (${countType === CountType.Bookmarks ? category.bookmarkCount : category.videoCount})`;

export const CategorySelect = (props: Props) => {
    const options = [
        { value: '', label: props.allLabel ?? uncategorizedText },
        ...props.categories.map(cat => ({ value: cat.name, label: getLabel(cat, props.countType) }))
    ];
    const selected = options.find(o => o.value === props.value) || options[0];
    const compact = !!props.compact;

    return (
        <>
            <Form.Label style={{ display: compact ? 'none' : undefined }}>Category</Form.Label>
            <Select
                options={options}
                value={selected}
                name={props.name}
                onChange={opt => props.onChange(opt?.value || '')}
                isClearable={false}
                autoFocus={props.autoFocus}
                isDisabled={props.disabled}
                styles={getReactSelectStyles(compact)}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                {...(compact ? { isSearchable: false, menuPlacement: 'auto' } : {})}
            />
        </>
    );
}